import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { participateDropdownDataEs } from './participateDropdownData.es';
import type { ParticipateDropdownData } from './types/ParticipateDropdownData';

export const participateDropdownDataByLocale: Record<
  I18nLocale.ES,
  ParticipateDropdownData
> = {
  es: participateDropdownDataEs,
};
